import React, { useState } from 'react';
import { format } from 'date-fns';

import QueryCard from 'components/Meteorology/Shared/QueryCard';
import QueryCardHeader from 'components/Meteorology/Shared/QueryCard/Header';
import QueryCardChips from 'components/Meteorology/Shared/QueryCard/Chips';
import QueryCardChip from 'components/Meteorology/Shared/QueryCard/Chip';
import QueryCardTrigger from 'components/Meteorology/Shared/QueryCard/Trigger';
import ControlPanelSheet from 'components/Relatorios/Dessem/Mobile/ControlPanelSheet';
import useDessemControlPanel from 'hooks/Relatorios/Dessem/useDessemControlPanel';

import './index.scss';

/**
 * "Consulta atual" do Informe DESSEM no mobile: data do informe, chip do cenário aplicado e o
 * gatilho que abre o painel de controle (BottomSheet). É o **único** consumidor do
 * `useDessemControlPanel` no mobile e fica sempre montado, então o efeito D1 do hook (cenário
 * aplicado sem estudo no dia passa para o padrão) roda com a folha fechada e uma vez só; a folha
 * recebe o estado por props.
 */
export default function DessemConsultaCard() {
  const [sheetOpen, setSheetOpen] = useState(false);
  const painel = useDessemControlPanel();
  const { selecionada, cenarios, cenarioAplicado } = painel;
  const cenario = cenarios.find((c) => c.value === cenarioAplicado);

  return (
    <div className="dessem-consulta-card">
      <QueryCard>
        <QueryCardHeader label="Consulta atual" title={format(selecionada, 'dd/MM/yyyy')}>
          {cenario && (
            <QueryCardChips>
              <QueryCardChip>{cenario.label}</QueryCardChip>
            </QueryCardChips>
          )}
        </QueryCardHeader>
        <QueryCardTrigger onClick={() => setSheetOpen(true)} />
      </QueryCard>

      <ControlPanelSheet
        // eslint-disable-next-line react/jsx-props-no-spreading
        {...painel}
        open={sheetOpen}
        dismiss={() => setSheetOpen(false)}
      />
    </div>
  );
}
